module.exports = __webpack_public_path__ + "img/pr-6.d810c099.png";